import React, { useState, useEffect, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Delete } from "@material-ui/icons/";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import UseFetchData from "../../../hooks/UseFetchData";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import Moment from 'moment';

const UserCreate = (props) => {
    const [Mode, setMode] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [EmpName, setEmpName] = useState('');
    const [UserName, setUserName] = useState('');
    const [Password, setPassword] = useState('');
    const [UserType, setUserType] = useState('');
    const [DOB, setDOB] = useState('');
    const [DOJ, setDOJ] = useState('');
    const [EmailPassword, setEmailPassword] = useState('');
    const [Department, setDepartment] = useState('');
    const [Designation, setDesignation] = useState('');
    const [UserGroup, setUserGroup] = useState('');
    const [StoreName, setStoreName] = useState('');
    const [ReportingOfficer, setReportingOfficer] = useState('');
    const [Address1, setAddress1] = useState("");
    const [Address2, setAddress2] = useState("");
    const [Email, setEmail] = useState('');
    const [Email1, setEmail1] = useState('');
    const [Mobile, setMobile] = useState('');
    const [Phone, setPhone] = useState('');
    const [deleteresponse, DeleteUserData] = UseFetchData();
    const [Remarks, setRemarks] = useState('');
    const [IsActive, setIsActive] = useState('');
    const [response, fetchData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [Departmentcmb, setDepartmentcmb] = useState([]);
    const [Designationcmb, setDesignationcmb] = useState([]);
    const [UserGroupcmb, setUserGroupcmb] = useState([]);
    const [Storecmb, setStorecmb] = useState([]);
    // const [ReportingOfficercmb, setReportingOfficercmb] = useState([]);
    const [UserTypecmb, setUserTypecmb] = useState([]);
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);


    const validationSchema = Yup.object({
        EmpCode: Yup.string().required('Required!'),
        EmpName: Yup.string().required('Required!'),
        UserName: Yup.string().required('Required!'),
        Password: Yup.string().required('Required!'),
        UserType: Yup.string().required('Required!'),
        IsActive: Yup.string().required('Required!'),
        Email: Yup.string().required('Required!'),
        EmailPassword: Yup.string().required('Required!')
    });

    const OnDelete = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("UserID", props.UserID);
        DeleteUserData("User/DeleteUserDtls", bodyFormData);
    };

    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };


    const onSubmit = values => {
        setMode('Insert');
        var IsActive = '';
        if (values.IsActive === 'Y') {
            IsActive = '1';
        }
        else {
            IsActive = '0';
        }
        var UpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("UserID", props.UserID);
        bodyFormData.append("UserName", values.UserName);
        bodyFormData.append("Password", values.Password);
        bodyFormData.append("UserTypeID", values.UserType);
        bodyFormData.append("EmpCode", values.EmpCode);
        bodyFormData.append("EmpName", values.EmpName);
        bodyFormData.append("DOB", values.DOB);
        bodyFormData.append("DOJ", values.DOJ);
        bodyFormData.append("DepartmentID", values.Department);
        bodyFormData.append("DesignationID", values.Designation);
        bodyFormData.append("UserGroupID", values.UserGroup);
        bodyFormData.append("StoreID", values.StoreName);
        // bodyFormData.append("ReportingOfficerID", values.ReportingOfficer);
        bodyFormData.append("Address1", values.Address1);
        bodyFormData.append("Address2", values.Address2);
        bodyFormData.append("Email", values.Email);
        bodyFormData.append("Email1", values.Email1);
        bodyFormData.append("Mobile", values.Mobile);
        bodyFormData.append("Phone", values.Phone);
        bodyFormData.append("Remarks", values.Remarks);
        bodyFormData.append("EmailPassword", values.EmailPassword);
        bodyFormData.append("UpdatedByID", UpdatedByID);
        bodyFormData.append("IsActive", IsActive);
        fetchData("User/Save", bodyFormData);
    };

    const IsActiveOptions = [
        { key: 'Yes', value: 'Y' },
        { key: 'No', value: 'N' }
    ]

    useEffect(() => {
        if (deleteresponse.Response === true) {
            // alert("Data Deleted Succesfully.");
            props.setOpen(false);
            //   props.getByIDData()
        } else if (deleteresponse.Response === false) {
            alert("Failed.");
        }
    }, [deleteresponse]);

    useEffect(() => {
        debugger;
        if (response.Response === true) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (response.Response === false) {
            if (response.Message.includes('Already') === true) {
                alert(response.Message);
            }
            else {
                alert('Failed.');
            }
        }
        if (props.UserID !== '') {
            setMode('Update');
        }
        else {
            setMode('Insert');
        }
        if (response.length > 0 && Mode === 'Update') {
            var isActive = '';
            if (response[0].IsActive === "1") {
                isActive = 'Y';
            }
            else {
                isActive = 'N';
            }
            setEmpCode(response[0].EmpCode);
            setEmpName(response[0].EmpName);
            setUserName(response[0].UserName);
            setPassword(response[0].Password);
            setUserType(response[0].UserTypeID);
            setDOB((response[0].DOB === null) ? "" : Moment(response[0].DOB).format('YYYY-MM-DD'));
            setDOJ((response[0].DOJ === null) ? "" : Moment(response[0].DOJ).format('YYYY-MM-DD'));
            setDepartment((response[0].DepartmentID === null) ? "" : response[0].DepartmentID);
            setDesignation((response[0].DesignationID === null) ? "" : response[0].DesignationID);
            setUserGroup((response[0].UserGroupID === null) ? "" : response[0].UserGroupID);
            setStoreName((response[0].StoreID === null) ? "" : response[0].StoreID);
            setReportingOfficer((response[0].ReportingOfficerID === null) ? "" : response[0].ReportingOfficerID);
            // debugger;
            setAddress1(response[0].Address1 === null || response[0].Address1 === "null" ? "" : response[0].Address1);
            setAddress2(response[0].Address2 === null || response[0].Address2 === "null" ? "" : response[0].Address2);
            setEmail(response[0].Email);
            setEmailPassword(response[0].EmailPassword)
            setEmail1(response[0].Email1 === null || response[0].Email1 === "null" ? "" : response[0].Email1);
            setMobile(response[0].Mobile);
            setPhone(response[0].Phone);
            setRemarks(response[0].Remarks === null || response[0].Remarks === "null" ? "" : response[0].Remarks);
            setIsActive(isActive);
        }
    }, [response]);


    const UserTypData = (options) => {
        if (options !== undefined) {
            let UserType = options.map((data) =>
                <option
                    key={data.UserType}
                    value={data.UserTypeID}
                >
                    {data.UserType}
                </option>
            );
            setUserTypecmb(UserType)
        }
    }
    const DepartmentData = (options) => {
        if (options !== undefined) {
            let Department = options.map((data) =>
                <option
                    key={data.Department}
                    value={data.DepartmentID}
                >
                    {data.Department}
                </option>
            );
            setDepartmentcmb(Department)
        }
    }
    const DesignationData = (options) => {
        if (options !== undefined) {
            let Designation = options.map((data) =>
                <option
                    key={data.Designation}
                    value={data.DesignationID}
                >
                    {data.Designation}
                </option>
            );
            setDesignationcmb(Designation)
        }
    }

    const UserGroupData = (options) => {
        if (options !== undefined) {
            let UserGroup = options.map((data) =>
                <option
                    key={data.UserGroup}
                    value={data.UserGroupID}
                >
                    {data.UserGroup}
                </option>
            );
            setUserGroupcmb(UserGroup)
        }
    }

    const StoreData = (options) => {
        if (options !== undefined) {
            let UserGroup = options.map((data) =>
                <option
                    key={data.StoreName}
                    value={data.StoreID}
                >
                    {data.StoreName}
                </option>
            );
            setStorecmb(UserGroup)
        }
    }

    // const ReportingOfficerData = (options) => {
    //     if (options !== undefined) {
    //         let UserName = options.map((data) =>
    //             <option
    //                 key={data.UserName}
    //                 value={data.UserID}
    //             // value={data.UserID}
    //             >
    //                 {data.UserName}
    //             </option>
    //         );
    //         setReportingOfficercmb(UserName)
    //     }
    // }
    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["UserType"] !== undefined && ComboDataResponse["Department"] !== undefined && ComboDataResponse["Designation"] !== undefined && ComboDataResponse["UserGroup"] !== undefined) {
                UserTypData(ComboDataResponse["UserType"]);
                DepartmentData(ComboDataResponse["Department"]);
                DesignationData(ComboDataResponse["Designation"]);
                UserGroupData(ComboDataResponse["UserGroup"]);
                StoreData(ComboDataResponse["CmbStore"]);
                // ReportingOfficerData(ComboDataResponse["Reporting"]);
                console.log(ComboDataResponse["Reporting"]);
                if (props.UserID !== '') {
                    setMode('Update');
                    GetUserData();
                }
                else {
                    setMode('Insert');
                }
            }
        }
    }, [ComboDataResponse]);

    useEffect(() => {
        GetComboData();
    }, [])

    const GetUserData = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("UserID", props.UserID);
        fetchData("User/GetByID", bodyFormData);
    };
    const GetComboData = () => {
        fetchComboData("User/ComboData");
    };

    const onSelectChange = (e) => {
        // debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "DOB") {
                setDOB(targetvalue)
            }
            else if (targetname === "DOJ") {
                setDOJ(targetvalue)
            }
            else if (targetname === "Department") {
                setDepartment(targetvalue)
            }
            else if (targetname === "Designation") {
                setDesignation(targetvalue)
            }
            else if (targetname === "UserGroup") {
                setUserGroup(targetvalue)
            }
            else if (targetname === "StoreName") {
                setStoreName(targetvalue)
            }
            // else if (targetname === "ReportingOfficer") {
            //     setReportingOfficer(targetvalue)
            // }
            else if (targetname === "Address1") {
                setAddress1(targetvalue)
            }
            else if (targetname === "Address2") {
                setAddress2(targetvalue)
            }
            else if (targetname === "Email") {
                setEmail(targetvalue)
            }
            else if (targetname === "Email1") {
                setEmail1(targetvalue)
            }
            else if (targetname === "Mobile") {
                setMobile(targetvalue)
            }
            else if (targetname === "Phone") {
                setPhone(targetvalue)
            }
            else if (targetname === "Remarks") {
                setRemarks(targetvalue)
            }
            else if (targetname === "EmailPassword") {
                setEmailPassword(targetvalue)
            }
        }
        else {
            if (targetname === "DOB") {
                setDOB("")
            }
            else if (targetname === "DOJ") {
                setDOJ("")
            }
            else if (targetname === "Department") {
                setDepartment("")
            }
            else if (targetname === "Designation") {
                setDesignation("")
            }
            else if (targetname === "UserGroup") {
                setUserGroup("")
            }
            else if (targetname === "UserGroup") {
                setStoreName("")
            }
            // else if (targetname === "ReportingOfficer") {
            //     setReportingOfficer("")
            // }
            else if (targetname === "Address1") {
                setAddress1("")
            }
            else if (targetname === "Address2") {
                setAddress2("")
            }
            else if (targetname === "Email") {
                setEmail("")
            }
            else if (targetname === "Email1") {
                setEmail1("")
            }
            else if (targetname === "Mobile") {
                setMobile("")
            }
            else if (targetname === "Phone") {
                setPhone("")
            }
            else if (targetname === "Remarks") {
                setRemarks("")
            }
            else if (targetname === "EmailPassword") {
                setEmailPassword("")
            }
        }
    }

    return (
        <div>
            <Formik initialValues={{
                EmpCode: EmpCode, EmpName: EmpName, UserName: UserName, Password: Password, UserType: UserType, DOB: DOB,
                DOJ: DOJ, Department: Department, Designation: Designation, UserGroup: UserGroup, StoreName: StoreName, Address1: Address1,
                Address2: Address2, Email: Email, Email1: Email1, Mobile: Mobile, Phone: Phone, Remarks: Remarks, IsActive: IsActive, EmailPassword: EmailPassword
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={1} container>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Emp Code'
                                    name='EmpCode'
                                    value={EmpCode}
                                    onChange={(e) => { setEmpCode(e.target.value) }}
                                /* disabled={true}  */
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Emp Name'
                                    name='EmpName'
                                    ref={ref}
                                    value={EmpName}
                                    onChange={(e) => {
                                        setEmpName(e.target.value)
                                        handleChange()
                                    }}
                                // onChange={(e) => { setEmpName(e.target.value) }}
                                /* disabled={true}  */
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='User Name'
                                    name='UserName'
                                    ref={ref}
                                    value={UserName}
                                    onChange={(e) => {
                                        setUserName(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} ><BiztranControlsFormik
                                control='input'
                                type='password'
                                label='Password'
                                name='Password'
                                onChange={(e) => { setPassword(e.target.value) }}
                            /></Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='select'
                                    label='User Type'
                                    name='UserType'
                                    options={UserTypecmb}
                                    onChange={(e) => { setUserType(e.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='date'
                                    label='DOB'
                                    name='DOB'
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='date'
                                    label='DOJ'
                                    name='DOJ'
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='select'
                                    label='Department'
                                    name='Department'
                                    options={Departmentcmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='select'
                                    label='Designation'
                                    name='Designation'
                                    options={Designationcmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='select'
                                    label='GroupName'
                                    name='UserGroup'
                                    options={UserGroupcmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            {/* <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='select'
                                    label='GroupName'
                                    name='ReportingOfficer'
                                    options={ReportingOfficercmb}
                                    onChange={onSelectChange}
                                />
                            </Grid> */}
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='textarea'
                                    label='Address1'
                                    name='Address1'
                                    onChange={onSelectChange}

                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='select'
                                    label='Store Name'
                                    name='StoreName'
                                    options={Storecmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='email'
                                    label='Email'
                                    name='Email'
                                    onChange={onSelectChange}

                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='email'
                                    label='Email1'
                                    name='Email1'
                                    onChange={onSelectChange}

                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='password'
                                    label='Email Password'
                                    name='EmailPassword'
                                    onChange={onSelectChange}

                                />
                            </Grid>
                            {/* <Grid item xs={6}></Grid> */}
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='number'
                                    label='Mobile'
                                    name='Mobile'
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='number'
                                    label='Phone'
                                    name='Phone'
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='textarea'
                                    label='Remarks'
                                    name='Remarks'
                                    onChange={onSelectChange}
                                // ref={ref}
                                // value={Remarks}
                                // onChange={(e) => {
                                //     onSelectChange
                                //  handleChange()
                                // }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='radio'
                                    label='IsActive'
                                    name='IsActive'
                                    options={IsActiveOptions}
                                // onChange={(e)=>{setIsActive(e.target.value)}}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        {/* <BiztranControls.Button
                                            text="Delete"
                                            startIcon={<Delete />}
                                            onClick={() => {
                                                OnDelete();
                                            }}
                                        /> */}
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default UserCreate;
